import {
  userActionInterceptor,
  staticIdDecorator,
} from '../socketIO/user.action.interceptor';
import config from '../../config';
const CAR_3D_SYNC_TYPE_NAME = 'car3dSync';
@staticIdDecorator('Car3DActionSync')
class Car3DActionSync {
  listen() {
    this.reviceMessage = this.reviceMessage.bind(this);
    window.addEventListener('message', this.reviceMessage);
  }
  reviceMessage(event) {
    const origin = event.origin;
    if (!origin || (origin && origin.indexOf('.autohome.com.cn') === -1)) {
      return;
    }
    const data = event.data;
    if (!data || (data && data.action !== CAR_3D_SYNC_TYPE_NAME)) {
      return;
    }
    const params = data.params;
    this.sendToServe(params.id, params.methodName, params.args);
  }
  @userActionInterceptor({ methodName: 'sendToSource' })
  sendToServe(id, methodName, args) {
    console.log(id, methodName, args);
  }
  sendToSource(id, methodName, args) {
    const carContainer = document.getElementById('full-360-car');
    if (!carContainer) {
      return;
    }
    const carFrames = carContainer.getElementsByTagName('iframe');
    if (carFrames.length > 0) {
      const carFrame = carFrames[0];
      if (carFrame) {
        // const target = carFrame.contentWindow;
        //target.origin || target.location.protocol + target.location.host;
        const origin = config.car3d;
        carFrame.contentWindow.postMessage(
          { action: CAR_3D_SYNC_TYPE_NAME, params: { id, methodName, args } },
          origin
        );
      }
    }
  }
  dispose() {
    window.removeEventListener('message', this.reviceMessage);
    this.tranxceiver = null;
  }
}

export { Car3DActionSync };